export const LOCALIZED_DATE_INTERPOLATION_OPTIONS={interpolation:{escapeValue:!1}};